import { type ApplicationConfig } from '@angular/core';

import { provideAmpApplication } from '@amp/shared/app-shell';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAmpApplication({
      appId: 'admin',
      routes: appRoutes,
    }),
  ],
};
